import { getPointMachineAlarmsForSwing } from 'src/Providers/PointMachineAlarms'
import { useQueryWithErrorHandling } from './useQueryWithErrorHandling'

type UsePointMachineAlarmsParams = {
  swingId: string
  feFilterEnabled: boolean
}

/** Hook to get alarms at swing, in which it is good to know that swingId
 * is on the format
 * ASSETID_eventId1_eventId2_..._eventIdN
 * and that ASSETID is ignored backend.
 * @param UsePointMachineAlarmsParams - (Beware:) On the format { swingId }
 * a.k.a. { ASSETID_eventId1_eventId2_..._eventIdN }
 */
export const usePointMachineAlarms = ({ swingId, feFilterEnabled = true }: UsePointMachineAlarmsParams) => {
  const query = useQueryWithErrorHandling(
    ['pointMachineAlarms', { swingId, feFilterEnabled }],
    () => getPointMachineAlarmsForSwing(swingId, feFilterEnabled),
    {},
    'alarms.fetchError'
  )

  return {
    ...query,
    alarms: query.data,
  }
}
